import ApiService from './ApiService'

const PERCENTAGES_INPUTS = [
    'fee_annual_contract_admin',
    'insurance_fee',
    'insurance_stationary',
    'insurance_movable',
    'funding_spread',
    'fee_oneoff_contract_handling',
    'stamp_duty_perc',
    'breakeven_full',
    'breakeven_high',
    'breakeven_medium',
    'breakeven_low',
    'min_carry_full',
    'min_carry_high',
    'min_carry_medium',
    'min_carry_low',
    'residual_value_day1_percent',
    'residual_value_end_percent',
    'annual_refinancing_rate',
    'break_even',
]

const SettingsService = {
    _isPercentageInput(key) {
        return PERCENTAGES_INPUTS.findIndex((partialKey) => key.includes(partialKey)) > -1
    },

    getLists(route) {
        return ApiService.get(route)
    },

    async get(route, oem) {
        try {
            const { data } = await ApiService.get(route, oem)
            if (data.settings) {
                // special case for credit risk settings
                data.settings = Object.keys(data.settings).reduce((acc, key) => {
                    const name = key.split('.').join('-')
                    acc[name] = data.settings[key]
                    return acc
                }, {})
            }
            return Object.keys(data).reduce((acc, key) => {
                const name = key.split('.').join('-')

                if (this._isPercentageInput(key)) {
                    acc[name] = data[key] * 100
                } else {
                    acc[name] = data[key]
                }
                return acc
            }, {})
        } catch (error) {
            console.error('Error fetching settings:', error)
            throw error
        }
    },

    async update(route, params = {}, oem) {
        try {
            const data = Object.keys(params).reduce((acc, key) => {
                if (this._isPercentageInput(key)) {
                    acc[key] = params[key] / 100
                } else {
                    acc[key] = params[key]
                }
                return acc
            }, {})

            const response = await ApiService.post(route, data, oem)
            return response.data
        } catch (error) {
            console.error('Error updating settings:', error)
            throw error
        }
    },

    togglePermission(role, data) {
        return ApiService.post('admin.roles_toggle_permission', data, role)
    },

    createRole(data) {
        return ApiService.post('admin.roles_create', data)
    },

    updateRole(role, data) {
        return ApiService.post('admin.roles_edit', data, role)
    },

    deleteRole(role) {
        return ApiService.delete('admin.roles_delete', role)
    },
}

export default SettingsService
